import { api } from './api'
import type { CommitteeAppointment, CommitteePosition } from '@riverpark/types'

export async function getCommitteeAppointments(): Promise<{ data: CommitteeAppointment[] }> {
  return api.get<{ data: CommitteeAppointment[] }>('/committee/appointments')
}

export async function getCommitteeHistory(): Promise<{ data: CommitteeAppointment[] }> {
  return api.get<{ data: CommitteeAppointment[] }>('/committee/appointments/history')
}

export async function appointMember(payload: {
  memberId: string
  position: CommitteePosition
  startedAt?: number
  notes?: string
}): Promise<{ data: CommitteeAppointment }> {
  return api.post<{ data: CommitteeAppointment }>('/committee/appointments', payload)
}

export async function endAppointment(id: string): Promise<{ ok: boolean }> {
  return api.delete<{ ok: boolean }>(`/committee/appointments/${id}`)
}
